import React from "react";
import CustomTable from "components/common/CustomTable";

type InventoryItem = {
    component: string;
    warehouse: string;
    quantity: string;
    hasStarIcon?: boolean;
};

type InventoryTableProps = {
    className?: string;
    data?: InventoryItem[];
};

const DUMMY_INVENTORY_DATA = [
    {
        component: "Garlic",
        warehouse: "San Antonio",
        quantity: "5,600 units",
        hasStarIcon: true
    },
    {
        component: "Tomatoes", 
        warehouse: "San Jose",
        quantity: "1,150 units",
        hasStarIcon: true
    },
    {
        component: "Salt",
        warehouse: "Columbus", 
        quantity: "6,200 units",
        hasStarIcon: false
    },
    {
        component: "Pepper",
        warehouse: "San Diego",
        quantity: "4,820 units", 
        hasStarIcon: false
    },
    {
        component: "Basil",
        warehouse: "Boston",
        quantity: "950 units",
        hasStarIcon: false
    },
    {
        component: "Jars",
        warehouse: "Houston",
        quantity: "8,100 units",
        hasStarIcon: false
    },
    {
        component: "Lids",
        warehouse: "Philadelphia", 
        quantity: "12,300 units",
        hasStarIcon: false
    },
    {
        component: "Case boxes",
        warehouse: "Jacksonville",
        quantity: "3,750 units",
        hasStarIcon: false
    },
    {
        component: "Case dividers",
        warehouse: "Austin",
        quantity: "7,900 units",
        hasStarIcon: false
    }
];

const InventoryTable: React.FC<InventoryTableProps> = ({ className, data }) => {
    // Use provided data 
    const inventoryData = data && data.length > 0 ? data : DUMMY_INVENTORY_DATA;
    const tableHeader = [
        {
            title: (
                <div className="flex items-center gap-2">
                    <span>Components</span>
                    <i className="ri-information-line text-slate-400 text-sm"></i>
                </div>
            ),
            widthClass: "min-w-[200px] w-[200px]"
        },
        {
            title: (
                <div className="flex items-center gap-2">
                    <span>Warehouse</span>
                    <i className="ri-information-line text-slate-400 text-sm"></i>
                </div>
            ),
            widthClass: "min-w-[180px] w-[180px]"
        },
        {
            title: (
                <div className="flex items-center gap-2">
                    <span>Quantity</span>
                    <i className="ri-information-line text-slate-400 text-sm"></i>
                </div>
            ),
            widthClass: "min-w-[150px] w-[150px]"
        }
    ];

    const tableBody = inventoryData.map((item, index) => [
        {
            content: (
                <div className="flex items-center gap-3 py-4">
                    <div className="w-8 h-8 rounded shrink-0 flex items-center justify-center bg-slate-200">
                        <i className="ri-box-2-fill text-lg text-slate-500"></i>
                    </div>
                    <div className="flex items-center gap-2">
                        <i className={`ri-star-fill text-base ${
                            item.hasStarIcon ? "text-[#FCD34D]" : "text-slate-300"
                        }`}></i>
                        <span className="text-slate-900 text-sm font-semibold">{item.component}</span>
                    </div>
                </div>
            ),
            widthClass: "min-w-[200px] w-[200px]"
        },
        {
            content: (
                <span className="text-slate-700 text-sm font-medium py-4">{item.warehouse}</span>
            ),
            widthClass: "min-w-[180px] w-[180px]"
        },
        {
            content: (
                <span className="text-slate-700 text-sm font-semibold py-4">{item.quantity}</span>
            ),
            widthClass: "min-w-[150px] w-[150px]"
        }
    ]);

    return (
        <div className={`bg-gradient-to-br from-amber-50 to-orange-100 p-4 rounded-xl ${className}`}>
            <div className="border border-gray-200 rounded-lg bg-white overflow-x-scroll">
                <CustomTable
                    tableHeader={tableHeader}
                    tableBody={tableBody}
                    isScrollable={true}
                    isCellBordered={true}
                    tableClass="!border-none !bg-white"
                    headerContainerClass="!bg-gray-50 !border-b !border-gray-200"
                    headerItemClass="text-xs font-semibold text-slate-700 py-4"
                    bodyItemClass="!bg-white hover:!bg-gray-50 !border-b !border-gray-100 last:!border-b-0"
                    tableContainerClass="!max-h-none !bg-white"
                    scrollWithin={true}
                />
            </div>
        </div>
    );
};

export default InventoryTable;
